import { LocaleWrapper } from "./LocaleWrapper";

export const locale = ({ registerAction }) => {
  registerAction({
    target: "$REACT_ROOT_WRAPPER",
    handler: { component: LocaleWrapper }
  });
};
